import { useAuth } from "@/contexts/auth-context";
import { router, useFocusEffect } from "expo-router";
import React, { useCallback } from "react";
import { Linking, Platform, StyleSheet } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import { WebView } from "react-native-webview";
import { ScreenHeader } from "./common/ScreenHeader";
import { Loader } from "./ui/loader";

const isWeb = Platform.OS === "web";

export const WebViewUI = ({
  title,
  url,
  handleShouldStartLoadWithRequest,
  showMenu = false,
}: {
  title: string;
  url: string;
  handleShouldStartLoadWithRequest?: (request: any) => boolean;
  showMenu?: boolean;
}) => {
  const { theme } = useAuth();

  useFocusEffect(
    useCallback(() => {
      if (isWeb) {
        Linking.openURL(url);
        router.back();
      }
    }, [url]),
  );

  return (
    <SafeAreaView
      style={[styles.container, { backgroundColor: theme.background }]}
    >
      <ScreenHeader title={title} showMenu={showMenu} />

      <WebView
        source={{ uri: url }}
        style={[styles.webview]}
        onShouldStartLoadWithRequest={handleShouldStartLoadWithRequest}
        startInLoadingState={true}
        javaScriptEnabled={true}
        domStorageEnabled={true}
        originWhitelist={["*"]}
        renderLoading={() => <Loader />}
      />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  webview: {
    flex: 1,
  },
});
